import MerchantMenuUploadPage from '../../../components/merchant/inventory/MerchantMenuUploadPage'

export default function MenuUpload() {
  return <MerchantMenuUploadPage />
}
